<template lang="pug">
  b-container(:style="{height: $breakpoint.mdUp ? '100%' : 'auto', overflow: $breakpoint.mdUp ? 'hidden': 'auto'}")
    b-row(style="height:100%;")
      b-col.br-1(md="auto", style="overflow-y:auto;height:100%;")
        h4.mb-3 Configuración
        b-nav(vertical)
          b-nav-item(:to="{name: 'Platforms'}", v-if="$can('read', 'settings-platforms-view')", link-classes="account-link")
            message-square-icon.icon-sm.mr-2.mb-1
            span Plataformas
          b-nav-item(:to="{name: 'Facebook Shops'}", v-if="isEcommerce && $can('read', 'settings-platforms-view')", link-classes="account-link")
            v-icon.mr-2(name="brands/facebook")
            span Facebook Shops
          //- b-nav-item(:to="{name: 'Ecommerce Settings'}", v-if="$can('read', 'settings-ecommerce-view')") Ecommerce
          b-nav-item(:to="{name: 'Parameters'}", v-if="$can('update', 'parameter')", link-classes="account-link")
            sliders-icon.icon-sm.mb-1.mr-2
            span Parámetros
          b-nav-item(:to="{name: 'Account Configuration'}", v-if="$can('update', 'account-configuration')", link-classes="account-link")
            settings-icon.icon-sm.mb-1.mr-2
            span Ajustes
          b-nav-item(:to="{name: 'IA Configuration'}", v-if="$can('update', 'account-configuration')", link-classes="account-link")
            settings-icon.icon-sm.mb-1.mr-2
            span Ajustes IA
          b-nav-item(:to="{name: 'Advanced'}", v-if="$can('update', 'account-configuration')", link-classes="account-link")
            settings-icon.icon-sm.mb-1.mr-2
            span General
          b-nav-item(:to="{name: 'GoogleCalendars'}", link-classes="account-link")
            calendar-icon.icon-sm.mb-1.mr-2
            span Calendario de Google
          b-nav-item(:to="{name: 'my_account'}", link-classes="account-link")
            user-icon.icon-sm.mr-2.mb-1
            span {{user_name || 'Mi cuenta'}}
      b-col(style="overflow-y:auto;height:100%;")
        router-view
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const platformController = createNamespacedHelpers('platform')
const parameterController = createNamespacedHelpers('parameter')
const accountController = createNamespacedHelpers('account')

export default {
  computed: {
    ...platformController.mapState({
      platforms: (state) => state.platforms
    }),
    ...accountController.mapState({
      account: (state) => state.account
    }),
    isEcommerce() {
      return new RegExp('^konverza-ecommerce', 'i').test(this.account.type)
    },
    isLeadsGallery() {
      return new RegExp('^konverza-leads-gallery', 'i').test(this.account.type)
    },
    user_name() {
      return this.getCurrentUser() && this.getCurrentUser().first_name
        ? this.getCurrentUser().first_name
        : ''
    }
  },
  methods: {
    ...mapActions([
      'parameter/all',
      'parameter/all_parameters',
      'parameter/update_value',
      'parameter/associate',
      'parameter/disassociate',
      'account/get',
      'platform/all',
      'platform/get',
      'platform/create',
      'platform/update',
      'bmessaging/get_bmid',
      'account/update'
    ]),
    // GET ACCOUNT NAME AND REACTIVATIONTIME
    getBmessagingPlatform() {
      const self = this

      this['platform/get']({
        account_id: self.$route.params.account_id,
        platform_id: 'bmessaging',
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (
              res.resource.subscribed &&
              !document.getElementById('botlers-messaging-chat-iframe')
            ) {
              this.loadBMessaging()
            }
          }
        }
      })
    },
    // CREATE BMESSAGING WIDGET
    loadBMessaging() {
      const self = this
      this['bmessaging/get_bmid']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else if (res.resource.bmid) {
            const bm_params = {
              ui: { attachFiles: true, attachImages: true }
            }
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.defer = true
            script.src = process.env.VUE_APP_BMID_SDK
            script.onload = function () {
              console.log('script loaded')
            }
            script.setAttribute('id', 'botlers-messaging-sdk-v2')
            script.setAttribute('bmid', res.resource.bmid)
            script.setAttribute(
              'bm-params',
              encodeURIComponent(JSON.stringify(bm_params))
            )
            document.getElementsByTagName('head')[0].appendChild(script)
          } else {
            console.error(
              'No ID for bmessaging widget or bmessaging platform not enabled.'
            )
          }
        }
      })
    },
    // CONNECT PAGE
    createPlatform() {
      let self = this
      const json_data = {
        name: '',
        external_id: '',
        access_token: '',
        account_id: self.$route.params.account_id
      }

      this['platform/create']({
        ...json_data,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
          }
        }
      })
    },
    // CHANGE PLATFORM MODE
    updatePlatform(plat) {
      let self = this
      const json_data = {
        responding_mode: plat.responding_mode,
        confidence: parseFloat(plat.confidence) / 100,
        enabled: plat.enabled,
        platform_id: plat.platform_id,
        account_id: self.$route.params.account_id
      }

      this['platform/update']({
        ...json_data,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
          }
        }
      })
    }
    // UPDATE REACTIVATION TIME
  },
  mounted() {
    // this.getAccount()
    // this.getAccountPlatforms()
    // this.getParameters()
    this.getBmessagingPlatform()
  }
}
</script>

<style lang="scss" scoped>
.account-link {
  background: #f2f2f2;
  border-radius: 5px;
  margin-bottom: 10px;
  color: #6e84a3 !important;

  &:hover,
  &.router-link-exact-active {
    background: rgba(14, 92, 207, 0.1);
    color: black !important;
  }
}
</style>
